import { Color } from 'three';
import { IGradient } from '../types';

export const PLASMA: IGradient = [
  [0.0, new Color(0.241, 0.015, 0.61)],
  [0.1, new Color(0.387, 0.001, 0.654)],
  [0.2, new Color(0.524, 0.025, 0.653)],
  [0.3, new Color(0.651, 0.125, 0.596)],
  [0.4, new Color(0.752, 0.227, 0.513)],
  [0.5, new Color(0.837, 0.329, 0.431)],
  [0.6, new Color(0.907, 0.435, 0.353)],
  [0.7, new Color(0.963, 0.554, 0.272)],
  [0.8, new Color(0.992, 0.681, 0.195)],
  [0.9, new Color(0.987, 0.822, 0.144)],
  [1.0, new Color(0.94, 0.975, 0.131)],
];
